import { useState } from "react";
import ListingTable from "./ListingTable";
import { useListing } from "./useListing";
import { getAllBuyers, deleteBuyerListing, getAllRefinance, deleteRefinanceListing } from "./services/BuyerListingService";
import { getAllSellers, deleteSellerListing, getAllNetFirst, deleteNetFirstListing } from "./services/SellerListingService";
import DynamicBackButton from "../../../components/backbutton/BackButton";
import Toast from '../../../components/common/Toast';

export default function Open() {
  const [activeTab, setActiveTab] = useState("Seller Net Sheet");
  const headers = [
    { field: "preparedFor", label: "Client Name" },
    { field: "address", label: "Property Address" },
    { field: "salesPrice", label: "Sales Price" },
    { field: "createdAt", label: "Created Date" },
  ];
  const [toast, setToast] = useState({ message: "", visible: false, type: 'success' });
  const buyer = useListing(getAllBuyers, deleteBuyerListing, 10);
  const seller = useListing(getAllSellers, deleteSellerListing, 10);

  const refi = useListing(getAllRefinance, deleteRefinanceListing, 10);
  const netfirst = useListing(getAllNetFirst, deleteNetFirstListing, 10);

  const handleUpdateToaster = ({ message, visible, type = 'success' }) => {
    setToast({ message, visible, type });
    setTimeout(() => setToast({ message: "", visible: false, type: 'success' }), 5000);
  };

  const handleDelete = async (id, type) => {
    let res;

    switch (type) {
      case "seller":
        res = await seller.deleteItem(id);
        break;

      case "buyer":
        res = await buyer.deleteItem(id);
        break;

      case "refi":
        res = await refi.deleteItem(id);
        break;

      case "netfirst":
        res = await netfirst.deleteItem(id);
        break;

      default:
        res = await buyer.deleteItem(id);
    }

    if (res?.status === "success") {
      handleUpdateToaster({
        message: res.message || "Deleted successfully!",
        visible: true,
        type: "success",
      });
    } else {
      handleUpdateToaster({
        message: "Failed to delete",
        visible: true,
        type: "error",
      });
    }
  };


  return (
    <div className="calculater-layout">
      <div>
        <div className="back-inner">
          <div className="calculater-header search-filtr">
            <div className="ch-backbtn">
              <DynamicBackButton />
            </div>
            <div className="ch-middlenm txt-center">
              <h1>Open a previously created sheet Estimate</h1>
              <p>Choose one of the previously created reports</p>
            </div>
          </div>
        </div>
      </div>
      <div className="calc-container double-height opensection-a" style={{ alignItems: 'flex-start' }}>

        {/* Tab Navigation */}
        <div className="settings-tabs-wrapper">
          <ul className="settings-tabs">
            <li className={`tab-item ${activeTab === "Seller Net Sheet" ? "active" : ""}`}
              onClick={() => setActiveTab("Seller Net Sheet")} >Seller Net Sheet</li>
            <li className={`tab-item ${activeTab === "Buyer's Closing Costs" ? "active" : ""}`}
              onClick={() => setActiveTab("Buyer's Closing Costs")} >Buyer's Closing Costs</li>
            <li className={`tab-item ${activeTab === "Seller2Net" ? "active" : ""}`}
              onClick={() => setActiveTab("Seller2Net")} >Seller2Net</li>
            <li className={`tab-item ${activeTab === "Refinance" ? "active" : ""}`}
              onClick={() => setActiveTab("Refinance")} >Refinance</li>
          </ul>
        </div>

        <div className="tbl-type-a">

          {/* Seller listing table */}
          {activeTab === "Seller Net Sheet" &&
            <ListingTable
              title="Seller Net Sheet"
              headers={headers}
              {...seller}
              totalCount={seller.pagination?.total}
              onPageChange={(page) => seller.setPagination(p => ({ ...p, page }))}
              onSearch={seller.setSearchQuery}
              onSort={seller.sortData}
              onDelete={(id) => handleDelete(id, "seller")}
            />
          }

          {/* Buyer listing table */}
          {activeTab === "Buyer's Closing Costs" &&
            <ListingTable
              title="Buyer's Closing Costs"
              headers={headers}
              {...buyer}
              totalCount={buyer.pagination?.total}
              onPageChange={(page) => buyer.setPagination(p => ({ ...p, page }))}
              onSearch={buyer.setSearchQuery}
              onSort={buyer.sortData}
              onDelete={(id) => handleDelete(id, "buyer")}
            />
          }
          {/* Seller2Net listing table */}
          {activeTab === "Seller2Net" &&
            <ListingTable
              title="Seller2Net"
              headers={headers}
              {...netfirst}
              totalCount={netfirst.pagination?.total}
              onPageChange={(page) => netfirst.setPagination(p => ({ ...p, page }))}
              onSearch={netfirst.setSearchQuery}
              onSort={netfirst.sortData}
              onDelete={(id) => handleDelete(id, "netfirst")}
            />
          }

          {/* Refinance listing table */}
          {activeTab === "Refinance" &&
            <ListingTable
              title="Refinance"
              headers={headers}
              {...refi}
              totalCount={refi.pagination?.total}
              onPageChange={(page) => refi.setPagination(p => ({ ...p, page }))}
              onSearch={refi.setSearchQuery}
              onSort={refi.sortData}
              onDelete={(id) => handleDelete(id, "refi")}
            />
          }
        </div>
        <Toast message={toast.message} type={toast.type} visible={toast.visible} />
      </div>
    </div>
  );
}
